export default "__VITE_ASSET__5684a2de__"